export default __webpack_public_path__ + "static/media/hunny-mobile-cover.c1e14be3.png";